import React from "react";
import { useHierarchy } from "../contexts/HierarchyContext.jsx";

const NAV_SECTIONS = [
  {
    label: "Test",
    items: [
      { key: "dashboard", label: "Test Cases", icon: "\u25A3" },
      { key: "manual-call", label: "Manual Call", icon: "\u25C9" },
      { key: "manual-text", label: "Manual Text", icon: "\u2709" },
      { key: "history", label: "Run History", icon: "\u25D2" },
    ],
  },
  {
    label: "Data",
    items: [
      { key: "patients", label: "Patients", icon: "\u25CB" },
      { key: "physicians", label: "Physicians", icon: "\u2695" },
      { key: "physician-match", label: "Physician Match", icon: "\u25CE" },
    ],
  },
  {
    label: "Config",
    items: [
      { key: "library", label: "Library", icon: "\u{1F4DA}" },
      { key: "github", label: "GitHub Sync", icon: "\u{1F517}" },
      { key: "settings", label: "Settings", icon: "\u2699" },
    ],
  },
];

export default function Sidebar({ page, onNavigate }) {
  const {
    orgs, tenants, subTenants,
    orgId, tenantId, subTenantId,
    setOrgId, setTenantId, setSubTenantId,
    currentSubTenant,
  } = useHierarchy();

  return (
    <nav style={s.sidebar}>
      {/* Brand */}
      <div style={s.brand}>
        <div style={s.brandIcon}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 2L2 7l10 5 10-5-10-5z"/>
            <path d="M2 17l10 5 10-5"/>
            <path d="M2 12l10 5 10-5"/>
          </svg>
        </div>
        <span style={s.brandText}>AgentTest</span>
      </div>

      {/* Hierarchy selectors */}
      <div style={s.hierarchyBlock}>
        <div style={s.selectorGroup}>
          <div style={s.selectorLabel}>Organization</div>
          <select style={s.selector} value={orgId} onChange={(e) => setOrgId(e.target.value)}>
            {orgs.length === 0 && <option value="">No organizations</option>}
            {orgs.map((o) => <option key={o._id} value={o._id}>{o.name}</option>)}
          </select>
        </div>

        <div style={s.selectorGroup}>
          <div style={s.selectorLabel}>Tenant</div>
          <select style={s.selector} value={tenantId} onChange={(e) => setTenantId(e.target.value)} disabled={tenants.length === 0}>
            {tenants.length === 0 && <option value="">—</option>}
            {tenants.map((t) => <option key={t._id} value={t._id}>{t.name}</option>)}
          </select>
        </div>

        <div style={s.selectorGroup}>
          <div style={s.selectorLabel}>Sub-Tenant</div>
          <select style={s.selector} value={subTenantId} onChange={(e) => setSubTenantId(e.target.value)} disabled={subTenants.length === 0}>
            {subTenants.length === 0 && <option value="">—</option>}
            {subTenants.map((st) => <option key={st._id} value={st._id}>{st.name}</option>)}
          </select>
        </div>

        {currentSubTenant?.specialty && (
          <div style={s.specialtyBadge}>{currentSubTenant.specialty}</div>
        )}
      </div>

      {/* Navigation */}
      <div style={s.navBody}>
        {NAV_SECTIONS.map((section) => (
          <div key={section.label} style={s.navSection}>
            <div style={s.navSectionLabel}>{section.label}</div>
            {section.items.map((item) => (
              <button
                key={item.key}
                onClick={() => onNavigate(item.key)}
                style={{ ...s.navItem, ...(page === item.key ? s.navItemActive : {}) }}
              >
                <span style={s.navIcon}>{item.icon}</span>
                {item.label}
              </button>
            ))}
          </div>
        ))}
      </div>
    </nav>
  );
}

const s = {
  sidebar: {
    width: 220,
    background: "#0f0f0f",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    flexShrink: 0,
    borderRight: "1px solid #1f1f1f",
    overflowY: "auto",
  },
  brand: {
    display: "flex", alignItems: "center", gap: 10,
    padding: "16px 16px 12px", borderBottom: "1px solid #1f1f1f",
  },
  brandIcon: {
    width: 28, height: 28, borderRadius: 6, background: "#1a1a1a",
    display: "flex", alignItems: "center", justifyContent: "center", color: "#fff",
  },
  brandText: { fontSize: 15, fontWeight: 600, letterSpacing: "-0.01em" },
  hierarchyBlock: {
    padding: "10px 12px", borderBottom: "1px solid #1f1f1f",
    display: "flex", flexDirection: "column", gap: 6,
  },
  selectorGroup: {},
  selectorLabel: {
    fontSize: 9, fontWeight: 500, color: "#555", textTransform: "uppercase",
    letterSpacing: "0.06em", marginBottom: 2,
  },
  selector: {
    width: "100%", background: "#1a1a1a", color: "#ddd", border: "1px solid #2a2a2a",
    borderRadius: 4, padding: "5px 6px", fontSize: 12, outline: "none",
  },
  specialtyBadge: {
    fontSize: 9, color: "#888", textTransform: "capitalize", marginTop: 2, textAlign: "center",
  },
  navBody: { flex: 1, padding: "8px 0" },
  navSection: { padding: "4px 0" },
  navSectionLabel: {
    fontSize: 10, fontWeight: 500, color: "#555", textTransform: "uppercase",
    letterSpacing: "0.05em", padding: "10px 16px 4px",
  },
  navItem: {
    display: "flex", alignItems: "center", gap: 8, width: "100%",
    padding: "7px 16px", border: "none", background: "transparent",
    color: "#999", textAlign: "left", fontSize: 13, fontWeight: 400,
    borderRadius: 0, cursor: "pointer", letterSpacing: "-0.01em",
  },
  navItemActive: { color: "#fff", background: "#1a1a1a" },
  navIcon: { fontSize: 13, opacity: 0.7, width: 18, textAlign: "center" },
};
